// extracted by mini-css-extract-plugin
export default {"ProductsCard":"styles_ProductsCard__1gZZF","tabHeader":"styles_tabHeader__5Z2T7","button":"styles_button__9kH0h","selector":"styles_selector__Nvpjm","tabs":"styles_tabs__YPQg9"};